<!-- 关于乐范 -->
<template>
	<div class="lefan-about">
		<HNB active="关于我们"></HNB>
		<div class="title-banner" :style="backgroundUrl">
			<p>关于我们</p>
		</div>
		<div class="AUC" >
			<div class="AUC-list">
				<div class="AUC-body" v-for="(item,index) in golftitle" :key="item.name" @click="choose(index)">
					<div class="AUC-item-name" :class="{'active':currentindex==index}">
						{{item.name}}
						<span class="AUC-body-line" v-show="index!=3">|</span>
					</div>

				</div>
			</div>
			<!--  class="animated fadeInRight"-->
			<div class="showbannner">
				<div class="fourmodel">

					<transition  name="fade" >
						<component v-bind:is="view"></component>
					</transition>
				</div>
			</div>
		</div>
		<BS :BsTitle="bsTitle"></BS>
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import BS from '../components/bottomShow'
	import golf from '../components/golf'
	import LC from '../components/LfCourse'
	import News from '../components/newsinfo.vue'
	import LH from '../components/LfHonor';
	export default {
		name: 'index',
		data() {
			return {
				view: 'golf',
				
				golftitle: [{
					name: '走进乐范',
					path: '/golf'
				}, {
					name: '乐范历程',
					path: '/LC'
				}, {
					name: '奖项荣誉',
					path: ''
				}, {
					name: '信息资讯',
					path: '/News'
				}],
				currentindex: '',
				bsTitle: ['关于我们', '走进乐范'],
				backgroundUrl: 'background-image: url(' + this.GLOBAL.imgHost + '/images/about-us-bg.png);'
			}
		},
		components: {
			HNB,
			BS,
			golf,
			LC,
			LH,
			News
		},
		methods: {

			choose(index) {

				if (index == 2) {
					this.bsTitle = ['关于我们', '荣誉奖项']
					this.view = 'LH'
					this.currentindex = 2
					
				} else if (index == 0) {
					this.bsTitle = ['关于我们', '走进乐范']
					this.view = 'golf'
				
					this.currentindex = 0
				} else if (index == 1) {
					this.bsTitle = ['关于我们', '乐范历程']
					this.view = 'LC'
					
					this.currentindex = 1
				} else if (index == 3) {
					this.bsTitle = ['关于我们', '信息资讯']
					this.currentindex = 3
					this.view = 'News'
			
				}

				// console.log(this.currentindex)


			}

		}
	}
</script>

<style>
	@import url("../common/animate.min.css");
	      .fade-enter-active, .fade-leave-active {
	        transition: all 1s
	      }
	      .fade-enter, .fade-leave-active {
	        opacity: 0;
	  position: relative;
	      }
	      .fade-enter {
	        transform: translateX(1024px);
	      }
	      .fade-leave-active {
	        transform: translateX(-1024px);
	  position: absolute; 
	      }
	


	.showbannner {
		width: 100%;
		overflow: hidden;
	}

	.fourmodel {
		display: flex;
		flex-direction: row;
		position: relative;
		left: 0%;
	}

	.title-banner {
		width: 100%;
		height: 450px;

		background-repeat: no-repeat;
		background-position: center;
		background-origin: content-box;
		background-size: 100% 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: white;
		font-size: 1.875rem;
		letter-spacing: 5px;
		font-weight: 650;
		text-shadow: 0px 4px 23px rgba(1, 8, 35, 0.33);
	}

	.AUC {
		max-width: 1024px;
		margin: auto;
	}

	.AUC-list {
		display: flex;
		margin-top: 30px;
	}

	.AUC .AUC-body {
		flex: 1;
		height: 60px;
		cursor: pointer;
		position: relative;

	}

	.AUC .AUC-body:nth-child(4) {
		border: 0 solid
	}

	.AUC-item-name {
	font-family: Alibaba-PuHuiTi-M;
		margin: auto;
		width: 30%;
		font-size: 18px;
		 
		font-weight: 650;
		color: rgba(24, 24, 24, 1);
		line-height: 90px;
		
	}

	.AUC-body-line {
		position: absolute;
		right: 0;
		width: 1px;
		height: 20px;
		color: rgba(204, 204, 204, 1);
		opacity: 0.7;

	}

	.lefan-about .active {
		border-bottom: 2px solid rgba(0, 199, 133, 1);

	}
</style>
